<template>
  <section class="w-100">
    <label>{{ $t(phoneNumberInputText) }}</label>
    <b-form-input
      id="phoneNumber"
      ref="phoneNumberInput"
      v-model="phoneNumber"
      name="phoneNumber"
      type="tel"
      pattern="[0-9]"
      maxlength="12"
      v-mask="'############'"
      class="pbone_mask"
      :placeholder="$t('security.phoneNumberPlaceHolder')"
    />
    <b-alert v-show="showPhoneNumberError" fade show variant="danger">
      <small>{{ $t('security.phoneNumberIsInvalid') }}</small>
    </b-alert>
  </section>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'PhoneNumberInput',
  props: {
    phoneNumberInputText: String
  },
  data () {
    return {
      phoneNumber: '',
      showPhoneNumberError: false
    }
  },
  methods: {
    showInputError () {
      this.showPhoneNumberError = true
      setTimeout(() => {
        this.showPhoneNumberError = false
      }, 5000)
    }
  }
})
</script>
